import can from 'can';
import Component from 'can/component/component';
import dtm from 'scripts/services/dtm';
import template from './modal-dialog.stache';
import appContext from 'scripts/app-context';

const timelineDialogModel = can.Map.extend({
    element: null,
    parent: null,
    define: {
        active: {
            type: 'htmlbool',
            value: false,
        },
        customBody: {
            type: 'htmlbool',
            value: false,
        },
        renderOnShow: {
            type: 'htmlbool',
            value: false,
        },
        title: {
            type: 'string',
            value: '',
        },
        smallFullScreen: {
            type: 'htmlbool',
            value: false,
        },
    },
    show(appendTarget) {
        let $el = this.attr('element');
        let $parent = $el.parent();
        const $htmlTag = this.element.closest('html');
        this.attr('parent', $parent);
        if ($el && $el.length) {
            appendTarget
                ? $el.appendTo(appendTarget)
                : $el.appendTo(document.body);
        }
        this.attr('active', true);
        this.dispatch('modalOpened', []);
        appendTarget
            ? appContext.model.dispatch('page-scroll-toggle', [false])
            : appContext.model.dispatch('page-scroll-toggle', [true]);
        $htmlTag.addClass('over-hidden');
    },
    hide() {
        const $modalDialog = this.element.closest('timeline-modal-dialog'),
            $timelineProgressbar = $modalDialog.find('timeline-progressbar'),
            $componentTimeline = this.element.closest(
                '.c-history-experience-timeline',
            ),
            $htmlTag = this.element.closest('html');
        if ($componentTimeline) {
            $componentTimeline.append($timelineProgressbar);
            $componentTimeline.removeClass('is-down');
        }
        if (!this.attr('active')) {
            return;
        }
        let $el = this.attr('element');
        this.attr('active', false);
        let $parent = this.attr('parent');
        if ($parent && $parent.length) {
            $el.appendTo($parent);
        } else {
            this.attr('element', null);
            can.remove($el);
        }
        this.dispatch('modalClosed', []);
        appContext.model.dispatch('page-scroll-toggle', [false]);
        $htmlTag.hasClass('over-hidden')
            ? $htmlTag.removeClass('over-hidden')
            : false;
    },
});

Component.extend({
    viewModel: timelineDialogModel,
    template: template,
    leakScope: false,
    tag: 'timeline-modal-dialog',
    events: {
        inserted: function($el) {
            this.viewModel.attr('element', $el);
            this.viewModel.dispatch('modalInserted', []);
        },
        '{document} keyup'(element, event) {
            if (event.keyCode === 27 && this.viewModel.attr('active')) {
                this.viewModel.hide();
            }
        },
        '.s-modal-overlay click'() {
            this.viewModel.hide();
        },
        '.s-btn-close click'() {
            this.viewModel.hide();
        },
        '.s-card-button__item click'(element) {
            const tagName = element.data('collection').toLowerCase();
            dtm.trackHistoryTimelineCollectionCtaClick(tagName);
        },
        '.swiper-wrapper click'(element, event) {
            if (!can.$(event.target).closest('modal-card').length) {
                this.viewModel.hide();
            }
        },
    },
});
